var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsSiDelivery = function SvgNnIconFlagsSiDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-SI-delivery_svg__Lager_47",
    "data-name": "Lager 47",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-SI-delivery_svg__cls-3{fill:#0062d9}.nn-icon-flags-SI-delivery_svg__cls-4{fill:#fff}.nn-icon-flags-SI-delivery_svg__cls-5{fill:#fd0}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v22.21H.25z",
    className: "nn-icon-flags-SI-delivery_svg__cls-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.25.25h49.97v11.1H.25z",
    className: "nn-icon-flags-SI-delivery_svg__cls-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.61 6.8.35 5.3a5.75 5.75 0 0 0 4.07 5.1 5.75 5.75 0 0 0 4.06-5.1l.36-5.3a10.36 10.36 0 0 0-8.84 0",
    className: "nn-icon-flags-SI-delivery_svg__cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.68 10.6-.66.89-1-2-1 2-.66-.89-1.65 2.21a5.12 5.12 0 0 0 3.32 3.72 5.11 5.11 0 0 0 3.31-3.72Z",
    className: "nn-icon-flags-SI-delivery_svg__cls-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SI-delivery_svg__wave",
    d: "M35.63 46.46a1.11 1.11 0 0 0 1.51.4 1.08 1.08 0 0 1 1.1 0 1.1 1.1 0 0 0 1.11 0 1.08 1.08 0 0 1 1.1 0 1.11 1.11 0 0 0 1.51-.4v.31a1.11 1.11 0 0 1-1.51.41 1.08 1.08 0 0 0-1.1 0 1.1 1.1 0 0 1-1.11 0 1.08 1.08 0 0 0-1.1 0 1.11 1.11 0 0 1-1.51-.41Z",
    className: "nn-icon-flags-SI-delivery_svg__cls-3",
    transform: "translate(-24.77 -33.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SI-delivery_svg__wave-2",
    d: "M35.63 47.09a1.11 1.11 0 0 0 1.51.41 1.08 1.08 0 0 1 1.1 0 1.1 1.1 0 0 0 1.11 0 1.08 1.08 0 0 1 1.1 0 1.11 1.11 0 0 0 1.55-.41v.32a1.11 1.11 0 0 1-1.51.41 1.08 1.08 0 0 0-1.1 0 1.15 1.15 0 0 1-1.11 0 1.08 1.08 0 0 0-1.1 0 1.11 1.11 0 0 1-1.51-.41Z",
    className: "nn-icon-flags-SI-delivery_svg__cls-3",
    "data-name": "wave",
    transform: "translate(-24.77 -33.09)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SI-delivery_svg__s",
    d: "m38.8 41.07.08.27.27-.06-.19.2.19.21-.27-.06-.08.27-.09-.27-.27.06.19-.21-.19-.2.27.06Z",
    className: "nn-icon-flags-SI-delivery_svg__cls-5",
    transform: "translate(-24.77 -33.09)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SI-delivery_svg__s-2",
    d: "m37.55 39.41.08.27.28-.06-.19.21.19.2-.28-.03-.08.27-.08-.27-.28.06.2-.2-.2-.21.28.06Z",
    className: "nn-icon-flags-SI-delivery_svg__cls-5",
    "data-name": "s",
    transform: "translate(-24.77 -33.09)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-SI-delivery_svg__s-3",
    d: "m40 39.41.08.27.28-.06-.19.21.19.2-.24-.03-.08.27L40 40l-.28.06.19-.2-.19-.21.28.06Z",
    className: "nn-icon-flags-SI-delivery_svg__cls-5",
    "data-name": "s",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.91 39.75-.37 5.41A5.42 5.42 0 0 1 38.8 50a5.41 5.41 0 0 1-3.75-4.79l-.36-5.41-.31.14.35 5.3a5.75 5.75 0 0 0 4.07 5.1 5.75 5.75 0 0 0 4.06-5.1l.36-5.3Z",
    style: {
      fill: "#ff3b0a"
    },
    transform: "translate(-24.77 -33.09)"
  }));
};
export default SvgNnIconFlagsSiDelivery;